// extracted by mini-css-extract-plugin
module.exports = {"imgBack":"Login_imgBack__34K66","imgBack2":"Login_imgBack2__3Xf1G"};